<rid-demo-page [title]="'<rid-content-card>'" previousRoute="/component-lab">
  <rid-content-card text="content" />
  <rid-content-card text="clickable" [isClickable]="true" />
  <rid-content-card text="correct" state="CORRECT" />
  <rid-content-card text="incorrect" state="INCORRECT" />
  <rid-content-card text="disabled" state="DISABLED" />
</rid-demo-page>
